<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>59、write Average Temp /Moisture/Weather（平均温度/湿度/天气情况）</span>
				<span>{{ data4.jz301 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz302 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz303" />
			</li>
			<li>
				<span>60、write Number of cranes used/Crane grabs capacity（几台吊机工作/吊机负荷）</span>
				<span>{{ data4.jz304 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz305 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz306" />
			</li>
			<li>
				<span>61、Average loading/Discharging rate per hour（每小时装卸货速率）</span>
				<span>{{ data4.jz307 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz308 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz309" />
			</li>
			<li>
				<span>62、Did you find handling equipment suitable（装卸货设备是否合适）</span>
				<span v-if="data4.jz310 == 1">yes</span>
				<span v-if="data4.jz310 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz311 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz312" />
			</li>
			<li>
				<span>63、Cargo will be loading in which hold（货物装载至哪个舱）</span>
				<span>{{ data4.jz313 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz314 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz315" />
			</li>
			<li>
				<span>64、Specify the type of equipment used the crane (chains, steelslings, nylon belt（吊具选择为链条，钢丝绳，尼龙带可以做成选择式）</span>
				<span>{{ data4.jz316 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz317 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz318" />
			</li>
			<li>
				<span>65、Specify the type of protection used by the equipment in order to reduce mechanical damages during the handling（装卸过程中有无采取保护措施防止机械损伤）</span>
				<span v-if="data4.jz319 == 1">yes</span>
				<span v-if="data4.jz319 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz320 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz321" />
			</li>
			<li>
				<span>66、Specify what type of protection the forklift is equipped with to reduce the damages during the handling（使用叉车装卸过程中有无采取保护措施防止损伤）</span>
				<span v-if="data4.jz322 == 1">yes</span>
				<span v-if="data4.jz322 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz323 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz324" />
			</li>
			<li>
				<span>67、Did you find Mixed SAME cargo inside the hold that can caused cargo mixing(有没有和其他相同货物混装)</span>
				<span v-if="data4.jz325 == 1">yes</span>
				<span v-if="data4.jz325 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz326 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz327" />
			</li>
			<li>
				<span>68、Did you find Cargo stored near the water? If yes evaluate the risk of possible water Spraying AS WELL in the note (货物储存地有没有靠近水源，有没有可能对货物造成影响)</span>
				<span v-if="data4.jz328 == 1">yes</span>
				<span v-if="data4.jz328 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz329 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz330" />
			</li>
			<li>
				<span>69、Did you find other good stacked over our cargo(无货是否被压)</span>
				<span v-if="data4.jz331 == 1">yes</span>
				<span v-if="data4.jz331 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz332 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz333" />
			</li>
			<li>
				<span>70、Did you find traces of leakage inside the holds?(舱内是否有渗漏情况)</span>
				<span v-if="data4.jz334 == 1">yes</span>
				<span v-if="data4.jz334 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz335 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz336" />
			</li>
			<li>
				<span>71、Did you find traces of condensations inside the holds(舱内是否有冷凝情况)</span>
				<span v-if="data4.jz337 == 1">yes</span>
				<span v-if="data4.jz337 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz338 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz339" />
			</li>
			<li>
				<span>72、Did you find the cargo stacked OUTSIDE of the warehouse(货物是否堆放在室外)</span>
				<span v-if="data4.jz340 == 1">yes</span>
				<span v-if="data4.jz340 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz341 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz342" />
			</li>
			<li>
				<span>73、Did you find the cargo stacked alongside the vessel(货物是否堆放在船边)</span>
				<span v-if="data4.jz343 == 1">yes</span>
				<span v-if="data4.jz343 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz344 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz345" />
			</li>
			<li>
				<span>74、Did you fine rubber and wooden base alongside vessel satis factory?(船边的橡胶片/垫木是否合适)</span>
				<span v-if="data4.jz346 == 1">yes</span>
				<span v-if="data4.jz346 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz347 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz348" />
			</li>
			<li>
				<span>75、Is the cargo covered with plastic sheeting in the hold(舱内是否覆盖彩条布)</span>
				<span v-if="data4.jz349 == 1">yes</span>
				<span v-if="data4.jz349 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz350 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz351" />
			</li>
			<li>
				<span>76、Does the cargo loading /discharge took place during rainy  weather?(是否雨中作业)</span>
				<span v-if="data4.jz352 == 1">yes</span>
				<span v-if="data4.jz352 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz353 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz354" />
			</li>
			<li>
				<span>77、Please write on the note all the equipments used for check the sizes the cargo inspected caliper/meter(是否通过游标卡尺/卷尺测量货物尺寸)</span>
				<span v-if="data4.jz355 == 1">yes</span>
				<span v-if="data4.jz355 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz356 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz357" />
			</li>
			<li>
				<span>78、Silver Nitrate test carried out randomly with negative result(随机硝酸银测试结果是否呈阴性)</span>
				<span v-if="data4.jz358 == 1">yes</span>
				<span v-if="data4.jz358 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz359 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz360" />
			</li>
			<li>
				<span>79、Material inspected +lashing +dunnaging before the hatches closing at the end of loading(绑扎材料/绑扎情况/垫木情况)</span>
				<span v-if="data4.jz361 == 1">yes</span>
				<span v-if="data4.jz361 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz362 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz363" />
			</li>
			<li>
				<span>80、is the hold, found i dry condition?(货舱是否干燥)</span>
				<span>{{ data4.jz364 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz365 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz366" />
			</li>
			<li>
				<span>81、Did you find cargo contained by oil or grease(是否发现油污)</span>
				<span>{{ data4.jz367 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz368 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz369" />
			</li>
			<li>
				<span>82、Did you find dock where the material has been placed found in dry condition(绑扎材料是否堆放在干燥区域)</span>
				<span>{{ data4.jz370 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz371 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz372" />
			</li>
			<li>
				<span>83、Show the type of the lashing used（wire rope/lashing bands/noly belt)(绑扎方式（钢丝绳，绑带，尼龙带）)</span>
				<span>{{ data4.jz373 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz374 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz375" />
			</li>
			<li>
				<span>84、Show the quantity and the quality of the wooden used(绑扎材料质量数量，垫木情况)</span>
				<span>{{ data4.jz376 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz377 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz378" />
			</li>
			<li>
				<span>85、Show if the cargo is properly stowed by use of the dunnaging on the tank top on sides /between tires(舱底)</span>
				<span>{{ data4.jz379 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz380 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz381" />
			</li>
			<li>
				<span>86、Show if the timber used is properly marked as per ISPM-15(垫木熏蒸情况)</span>
				<span>{{ data4.jz382 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz383 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz384" />
			</li>
			<li>
				<span>87、final stowage condition(最终积载图)</span>
				<span>{{ data4.jz385 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz386 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz387" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workStart4',
	components: {
		navTop
	},
	data() {
		return {
			data4: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					this.data4 = res.data3;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		p {
			color: #00fff0;
			font-size: 25px;
			line-height: 1em;
			text-align: center;
			font-weight: bold;
			margin-bottom: 10px;
		}
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
